import styled from "styled-components";

export const SelectScheduleContainer = styled.div`
  margin-top: 30px;

  .datetime-result-list {
    margin-top: 30px;
  }

  .appointments-available {
    button {
      min-height: auto;
      max-width: 250px;
    }
  }

  .available-months {
    margin-top: 30px;
    button {
      min-height: auto;
      max-width: 100px;
    }
  }

  h2,
  p {
    font-size: 1.3rem;
  }

  .container-dates-options.container-times-options {
    display: flex;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    margin: 0 auto;
    justify-content: center;
    box-sizing: border-box;
  }

  .container-times-options {
    margin-top: 30px;
  }

  .error {
    margin-top: 30px;
  }

  .dates-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }

  .text-md {
    font-size: 1.5rem;
  }

  button {
    font-weight: 600;
    min-height: 3.7em;
    width: 100%;
    max-width: 300px;
  }
`;
